import { List } from '@app/core/interfaces/list';
import { Selector } from '@ngxs/store';
import { ListingsStateModel } from './listings-state.model';
import { ListingsState } from './listings.state';
import { Country } from '@app/entities/countries/interfaces/country';

export class ListingsSelectors {
  @Selector([ListingsState])
  static categories(state: ListingsStateModel): List | undefined {
    return state.categories;
  }

  @Selector([ListingsState])
  static countries(state: ListingsStateModel): Country[] | undefined {
    return state.countries;
  }
}
